/**
 * Created by Alex Aguilar on 7/26/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .directive('webUiPopover', [webUiPopover])

    function webUiPopover(flightTimeService){
        var directive = {
            restrict: 'AC',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, $element, attributes) {
            $element.webuiPopover({
                title: attributes.title,
                content: attributes.content,
                placement: attributes.placement,
                trigger: attributes.trigger
            });
        }
    }
})();
